import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CaseStudy from '@/pages/home/components/CaseStudy';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://grainn-office.com';

const caseStudyJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'CollectionPage',
      '@id': `${siteUrl}/case-study#webpage`,
      url: `${siteUrl}/case-study`,
      name: '大阪 WEBサイト制作・SNS運用 制作実績・支援事例｜GRAINN',
      description: 'GRAINNが大阪の中小企業・個人事業主を支援した実績紹介。WEBサイト制作・SNS運用代行・デジタルマーケティングの具体的な成果事例をご覧ください。',
      inLanguage: 'ja',
      isPartOf: { '@id': `${siteUrl}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'ホーム', item: `${siteUrl}/` },
          { '@type': 'ListItem', position: 2, name: '制作実績', item: `${siteUrl}/case-study` },
        ],
      },
    },
  ],
};

export default function CaseStudyPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="min-h-screen">
      <title>大阪 WEBサイト制作・SNS運用 制作実績・支援事例｜GRAINN</title>
      <meta name="description" content="GRAINNが大阪の中小企業・個人事業主を支援した実績紹介。WEBサイト制作・SNS運用代行・デジタルマーケティングの具体的な成果事例をご覧ください。" />
      <link rel="canonical" href={`${siteUrl}/case-study`} />
      <JsonLd data={caseStudyJsonLd} id="case-study" />
      <Navbar />

      {/* Page Hero */}
      <section className="relative pt-44 pb-24 overflow-hidden bg-[#0D1B2A]">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=dark%20navy%20blue%20professional%20business%20presentation%20screen%20results%20data%20analytics%20charts%20minimalist%20office%20dark%20elegant%20background%20subtle%20light%20beams&width=1920&height=600&seq=casestudy-hero-bg&orientation=landscape"
            alt="制作実績"
            className="w-full h-full object-cover object-top opacity-15"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0D1B2A]/80 to-[#0D1B2A]" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
          <p className="text-[#C9A878] text-xs tracking-[0.4em] mb-5 uppercase">/ Case Study</p>
          <h1 className="text-5xl md:text-7xl font-bold text-white tracking-tight leading-tight mb-6">
            制作・支援実績
          </h1>
          <div className="w-16 h-px bg-[#C9A878]/60 mb-6" />
          <p className="text-white/60 text-lg max-w-xl leading-relaxed">
            実際にご支援したクライアントの事例をご紹介します。
          </p>
          <div className="flex items-center gap-2 mt-8 text-xs text-white/30">
            <Link to="/" className="hover:text-white/60 transition-colors">ホーム</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-white/60">制作実績</span>
          </div>
        </div>
      </section>

      <CaseStudy />

      <section className="py-20 bg-[#F8F5EF]">
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1C2B22] mb-5 tracking-tight">
            あなたのビジネスも成長させませんか
          </h2>
          <p className="text-[#666] mb-8 text-base leading-relaxed">
            同様の課題をお持ちの方、ぜひ一度ご相談ください。
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-[#1B2D5B] text-white px-10 py-4 rounded-full text-sm tracking-widest hover:bg-[#0D1B2A] transition-colors whitespace-nowrap"
          >
            <i className="ri-mail-send-line" />
            無料相談を申し込む
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}
